import React from "react";
import { ISelectQuestion, ISliderQuestion } from "../../constants/types";
import { Grid } from "../../UI/Grid";
import { sortByOrder } from "../../helpers/sortByOrder";
import { Typography } from "../../UI/Typography";
import { COLOR_BLUE_BAYOUX } from "../../constants/styles";

export const QuestionAnswerLables: React.FC<
  Pick<ISliderQuestion | ISelectQuestion, "answers">
> = (props) => (
  <Grid container justifyContent="space-between" wrap="nowrap">
    {sortByOrder(Object.values(props.answers)).map((answer: any) => (
      <Grid item key={answer.id}>
        <Typography
          color={COLOR_BLUE_BAYOUX}
          fontWeight={500}
          variant="caption"
        >
          {answer.text}
        </Typography>
      </Grid>
    ))}
  </Grid>
);
